export default __webpack_public_path__ + "static/media/edit_pencil.b4928997.svg";